import styled from 'styled-components';

export const FaqsContainer = styled.div`
    .faq-index {
        background: #f9f9f9 none repeat scroll 0 0;
        border: 1px solid #aaa;
        display: table;
        margin-bottom: 4em;
        margin-top: 40px;
        padding: 20px;
        width: auto;

        .title {
            font-weight: 700;
            text-align: center;
            font-size: 20px;
            margin-bottom: 20px;
        }

        ul {
            padding: 2px;
            list-style: outside none none !important;

            li {
                padding: 2px;
                list-style: outside none none !important;
                margin-bottom: 10px;
                line-height: 1.4em;
            }
        }
    }

    .faq-list {
        .faq-scroll {    
            scroll-margin-top: 100px;
        }

        .title {
            font-family: "museo sans";
            font-size: 24px;
            line-height: 32px;
            color:  #3f3f3f;
            margin-bottom: 32px;
            font-weight: 700;
        }
    
        .content {
            font-family: "museo sans";
            margin-bottom: 48px;
            color: rgb(9, 30, 66);
            font-weight: 300;
            

            p {
                margin-bottom: 15px;
                font-size: 16px;
                line-height: 27px;
                color: rgb(9, 30, 66);
            }

            ul {
                padding-left: 30px;

                li {
                    display: list-item;
                    position: relative;
                    padding-left: 20px;
                    font-size: 16px;
                    line-height: 27px;
                    color: rgb(9, 30, 66);
                }

                li::before {
                    content: "";
                    width: 6px;
                    height: 6px;
                    background: rgb(0, 79, 139);
                    position: absolute;
                    left: 0px;
                    top: 9px;
                    border-radius: 100%;
                }
            }
        }
    }

    .info-text {
        margin-top: 40px;
    }

`;
